angular.module( 'acme.view.application.donations.amount', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.donations.amount.list',
  'acme.view.application.donations.amount.controllers',
  'acme.common.directive.dataGrid',
  'acme.view.application.dataGrid.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var donationsAmount = {
        name: 'application.donations.amount',
        url: '/amount',
        views: {
          "subview-main": {
            controller: 'DonationsAmountController',
            templateUrl: 'views/application/views/donations/amount/amount.tpl.html'
          }
        },
        data: {
          pageTitle: '  '
        }
      };

    $stateProvider
      .state(donationsAmount);
});
